import { Component, type ReactNode } from 'react';

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // Surface it in the console too.
    console.error('Console crashed:', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
          <div className="max-w-lg rounded-xl border border-border bg-card p-6 shadow-sm">
            <h1 className="font-display text-lg font-semibold">Something broke</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              The console hit a runtime error. The message below tells us exactly
              what to fix.
            </p>
            <pre className="mt-4 overflow-auto rounded-lg bg-muted p-3 font-mono text-xs text-foreground">
              {this.state.error.message}
              {'\n\n'}
              {this.state.error.stack?.split('\n').slice(0, 6).join('\n')}
            </pre>
            <button
              onClick={() => location.reload()}
              className="mt-4 rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground transition hover:opacity-90"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
